<app-header></app-header>

<ng-container *ngIf="!isLoading">
    <div class="main-wrapper">
        <div class="breadcrumb-wrapper">
            <section>
                <nav>
                    <ol class="cd-breadcrumb custom-separator custom-icons">
                        <li><a routerLink="/dashboard"><i class="fa-solid fa-house"></i></a></li>
                        <li class="current"><a><i class="fa-solid fa-table-columns"></i>Metadata Overview</a></li>
                        <li class="breadcrumb-step"><i class="fa fa-sitemap" aria-hidden="true"></i> Classification and
                            Description Generation</li>
                        <li class="breadcrumb-step"><i class="fa-solid fa-square-poll-vertical"></i> Final Output</li>
                    </ol>
                </nav>
            </section>
        </div>

        <mat-card appearance="outlined" class="progress-card-main">
            <mat-card-header class="progress-card-header">
                <div class="progress-card-content">
                    <mat-card-title class="progress-card-title">Metadata Selection</mat-card-title>
                </div>
                <div class="progress-card-actions">
                    <button (click)="saveMetadata()" [disabled]="generateDescriptionLoading || metadataArray.length==0"
                        class="btn btn-primary generate-btn progress-generate-btn">
                        <ng-container>
                            Generate Classification
                            &nbsp;&nbsp;<i class="fa-solid fa-arrow-right"></i>
                        </ng-container>
                    </button>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class="completion-progress">
                    <span class="completion-label">Completion</span>
                    <span class="completion-value">{{completion_percentage}}%</span>
                </div>
                <div class="progress progress-container">
                    <div class="progress-bar progress-fill" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                        [style.width.%]="completion_percentage" [attr.aria-valuenow]="completion_percentage"></div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="container1" *ngIf="!generateDescriptionLoading">
        <div class="box1 database-panel" [class.active]="currentActiveTab === 'databases'">
            <div class="dashboard-content panel-container">
                <div *ngIf="currentActiveTab !== 'databases' && selectedDatabase" class="collapsed-view">
                    <button mat-fab color="primary" size="mini" (click)="expandSection('databases')" class="expand-btn">
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    <p class="vertical-text">
                        <span class="vertical-icon">
                            <i class="fa fa-database" aria-hidden="true"></i>
                        </span>
                        <span [matTooltip]="selectedDatabase" matTooltipPosition="above"
                            matTooltipShowDelay="300">{{selectedDatabase.substring(0, 15)}}<span
                                *ngIf="selectedDatabase.length>15">...</span>
                        </span>
                    </p>
                </div>
                <div *ngIf="currentActiveTab !== 'databases' && !selectedDatabase">
                    <p class="vertical-text vertical-text-empty">No database selected</p>
                </div>
                <div *ngIf="currentActiveTab === 'databases'">
                    <div class="panel-header">
                        <i class="fa fa-database panel-icon " aria-hidden="true"></i>
                        <h3 class="panel-title">Databases</h3>
                    </div>
                    <form class="example-form">
                        <mat-form-field appearance="outline"
                            class="example-full-width small-height search-field-container">
                            <mat-label>Search Database</mat-label>
                            <input matInput (keyup)="onInputDatabaseNameChange($event)" placeholder="Ex. DBY7Y6" #input>
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </form>

                    <div *ngIf="databases.length === 0" class="no-data-message">
                        <i class="fa fa-database" aria-hidden="true"></i>
                        No database found.
                    </div>

                    <div class="items-container">
                        <mat-card *ngFor="let item of databases; let i = index;" class="item-card"
                            [class.selected]="item === selectedDatabase" (click)="fetchSchemas(item)" mat-ripple>
                            <mat-card-content class="item-content">
                                <i class="fa fa-database" aria-hidden="true"></i>
                                <span class="item-name truncate-20" [matTooltip]="item" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item}}</span>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="box1 schema-panel" [class.active]="currentActiveTab === 'schemas'">
            <div class="dashboard-content panel-container">
                <div *ngIf="currentActiveTab !== 'schemas' && selectedSchema" class="collapsed-view">
                    <button mat-fab color="primary" size="mini" (click)="expandSection('schemas')" class="expand-btn">
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    <p class="vertical-text">
                        <span class="vertical-icon">
                            <i class="fa fa-sitemap" aria-hidden="true"></i>
                        </span>
                        <span [matTooltip]="selectedSchema" matTooltipPosition="above"
                            matTooltipShowDelay="300">{{selectedSchema.substring(0, 15)}}<span
                                *ngIf="selectedSchema.length>15">...</span>
                        </span>
                    </p>
                </div>
                <div *ngIf="currentActiveTab !== 'schemas' && !selectedSchema">
                    <p class="vertical-text vertical-text-empty">No schema selected</p>
                </div>
                <div *ngIf="currentActiveTab === 'schemas'">
                    <div class="panel-header">
                        <i class="fa fa-sitemap panel-icon " aria-hidden="true"></i>
                        <h3 class="panel-title">Schema</h3>
                    </div>
                    <form class="example-form">
                        <mat-form-field appearance="outline"
                            class="example-full-width small-height search-field-container">
                            <mat-label>Search Schema</mat-label>
                            <input matInput (keyup)="onInputSchemaNameChange($event)" placeholder="Ex. STDY7Y6" #input>
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </form>

                    <div *ngIf="schemas.length === 0 && !schemaLoading" class="no-data-message">
                        <i class="fa fa-sitemap" aria-hidden="true"></i>
                        No schema found.
                    </div>

                    <ng-container *ngIf="schemaLoading">
                        <div class="loading-spinner">
                            <svg viewBox="25 25 50 50">
                                <circle r="20" cy="50" cx="50"></circle>
                            </svg>
                        </div>
                    </ng-container>

                    <div class="items-container">
                        <mat-card *ngFor="let schema of schemas; let i = index;" class="item-card"
                            [class.selected]="schema == selectedSchema" (click)="fetchTables(schema)" mat-ripple>
                            <mat-card-content class="item-content">
                                <i class="fa fa-sitemap" aria-hidden="true"></i>
                                <span class="item-name truncate-20" [matTooltip]="schema" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{schema}}</span>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="box1 table-panel" [class.active]="currentActiveTab === 'tables'">
            <div class="dashboard-content panel-container">
                <div *ngIf="currentActiveTab !== 'tables' && selectedTable" class="collapsed-view">
                    <button mat-fab color="primary" size="mini" (click)="expandSection('tables')" class="expand-btn">
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    <p class="vertical-text">
                        <span class="vertical-icon">
                            <i class="fa fa-table" aria-hidden="true"></i>
                        </span>
                        <span [matTooltip]="selectedTable" matTooltipPosition="above"
                            matTooltipShowDelay="300">{{selectedTable.substring(0, 15)}}<span
                                *ngIf="selectedTable.length>15">...</span>
                        </span>
                    </p>
                </div>
                <div *ngIf="currentActiveTab !== 'tables' && !selectedTable">
                    <p class="vertical-text vertical-text-empty">No table selected</p>
                </div>
                <div *ngIf="currentActiveTab === 'tables'">
                    <div class="panel-header">
                        <i class="fa fa-table panel-icon " aria-hidden="true"></i>
                        <h3 class="panel-title">Table</h3>
                    </div>
                    <form class="example-form">
                        <mat-form-field appearance="outline"
                            class="example-full-width small-height search-field-container">
                            <mat-label>Search Table</mat-label>
                            <input matInput (keyup)="onInputTableNameChange($event)" placeholder="Ex. TDY7Y6" #input>
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </form>

                    <div *ngIf="tables.length === 0 && !tableLoading" class="no-data-message">
                        <i class="fa fa-table" aria-hidden="true"></i>
                        No table found.
                    </div>

                    <ng-container *ngIf="tableLoading">
                        <div class="loading-spinner">
                            <svg viewBox="25 25 50 50">
                                <circle r="20" cy="50" cx="50"></circle>
                            </svg>
                        </div>
                    </ng-container>

                    <div *ngIf="!isLoading" class="items-container">
                        <mat-card *ngFor="let table of tables; let i = index;" class="item-card"
                            [class.selected]="table == selectedTable" (click)="fetchMetadata(table)" mat-ripple>
                            <mat-card-content class="item-content">
                                <i class="fa fa-table" aria-hidden="true"></i>
                                <span class="item-name truncate-20" [matTooltip]="table" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{table}}</span>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="metadata-panel metadata-main-panel" [class.active]="currentActiveTab === 'meta'">
            <div *ngIf="metadataArray.length==0 && !metadataLoading" class="metadata-empty">
                <div class="empty-metadata-state">
                    <button mat-fab color="primary" class="expand-btn">
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                    <div class="empty-content">
                        <i class="fa fa-table large-icon " aria-hidden="true"></i>
                        <h3 class="empty-title">No Metadata Created</h3>
                        <p>Select a table to view metadata information</p>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="metadataLoading">
                <div class="loading-spinner-metadata margin-top-loader">
                    <svg viewBox="25 25 50 50">
                        <circle r="20" cy="50" cx="50"></circle>
                    </svg>
                </div>
            </ng-container>

            <div *ngIf="metadataArray.length>0 && !metadataLoading">
                <div class="dashboard-content metadata-content-wrapper">
                    <div *ngFor="let item of metadataArray; let itemIndex = index;" class="metadata-item">
                        <ng-container class="mt-3">
                            <div class="metadata-header-section">
                                <span class="metadata-path-info">
                                    <i class="fa fa-database" aria-hidden="true"></i> 
                                    <span class="truncate-50" [matTooltip]="item.database_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.database_name}}</span>&nbsp;
                                    <i class="fa fa-sitemap" aria-hidden="true"></i> 
                                    <span class="truncate-50" [matTooltip]="item.schemas[0].schema_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.schemas[0].schema_name}}</span>&nbsp;
                                    <i class="fa fa-table" aria-hidden="true"></i>
                                    <span class="truncate-50" [matTooltip]="item.schemas[0].tables[0].table_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.schemas[0].tables[0].table_name}}</span>
                                </span>
                                <span matTooltip="Delete" (click)="deleteTable('0ms', '0ms',item)"
                                    class="delete-metadata-btn">
                                    <i class="fa-solid fa-trash"></i>
                                </span>
                            </div>

                            <div class="metadata-form-section">
                                <mat-form-field appearance="outline" class="inline-field small-height metadata-field-1">
                                    <mat-label>Domain</mat-label>
                                    <input matInput placeholder="Enter Domain"
                                        [(ngModel)]="item.schemas[0].tables[0].table_metadata.domain">
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="inline-field small-height metadata-field-2">
                                    <mat-label>Business Type</mat-label>
                                    <input matInput placeholder="Enter Business Type"
                                        [(ngModel)]="item.schemas[0].tables[0].table_metadata.business_type">
                                </mat-form-field>

                                <mat-form-field appearance="outline"
                                    class="inline-field description-field small-height metadata-field-3">
                                    <mat-label>Table Description</mat-label>
                                    <textarea matInput
                                        [(ngModel)]="item.schemas[0].tables[0].table_metadata.user_table_description"
                                        placeholder="Enter Table Description" rows="1" maxlength="200">
                                    </textarea>
                                    <button mat-icon-button matSuffix matTooltip="Expand for detailed editing"
                                        (click)="openDescriptionDialog('table',item,null)" class="expand-btn">
                                        <mat-icon>open_in_full</mat-icon>
                                    </button>
                                    <mat-hint align="end">{{tableDescription.length || 0}}/200</mat-hint>
                                </mat-form-field>
                            </div>

                            <table class="comparison-table">
                                <colgroup *ngIf="isAtlanDatabase">
                                    <col style="width: 5%;">
                                    <col style="width: 15%;">
                                    <col style="width: 15%;">
                                    <col style="width: 10%;">
                                    <col style="width: 10%;">
                                    <col style="width: 15%;">
                                    <col style="width: 10%;">
                                    <col style="width: 15%;">
                                    <col style="width: 5%;">
                                </colgroup>
                                <colgroup *ngIf="!isAtlanDatabase">
                                    <col style="width: 5%;">
                                    <col style="width: 20%;">
                                    <col style="width: 30%;">
                                    <col style="width: 10%;">
                                    <col style="width: 30%;">
                                    <col style="width: 5%;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="select-all-cell">
                                            <mat-checkbox (change)="$event ? toggleAllRows($event,item) : null"
                                                class="my-white-unchecked" [checked]="item.checked">
                                            </mat-checkbox>
                                        </th>
                                        <th rowspan="2" class="column-name-header">Column Name</th>
                                        <th colspan="2" class="system-header snowflake">Snowflake</th>
                                        <th colspan="3" class="system-header atlan" *ngIf="isAtlanDatabase">Atlan</th>
                                        <th rowspan="2" class="instruction-cell">User Instruction</th>
                                        <th rowspan="2" class="actions-header">Actions</th>
                                    </tr>
                                    <tr class="column-headers">
                                        <th>Description</th>
                                        <th>Data Type</th>
                                        <th *ngIf="isAtlanDatabase">Term</th>
                                        <th *ngIf="isAtlanDatabase">Description</th>
                                        <th *ngIf="isAtlanDatabase">Data Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="field-row"
                                        *ngFor="let element of item.schemas[0].tables[0].metaData; let i = index">
                                        <td class="select-cell">
                                            <mat-checkbox (click)="$event.stopPropagation()"
                                                (change)="checkRow($event, element, item)" [checked]="element.checked">
                                            </mat-checkbox>
                                        </td>
                                        <td class="field-name">
                                            <span class="truncate-20" [matTooltip]="element.column_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{element.column_name}}</span>
                                    </td>
                                        <td class="data-cell">
                                            <span class="truncate-multiline"
                                                [matTooltip]="element.snowflake_metadata.description"
                                                matTooltipPosition="below"
                                                matTooltipClass="tooltip-wide">{{element.snowflake_metadata.description}}</span>
                                        </td>

                                        <td class="data-cell">
                                            @if(element.snowflake_metadata.data_type=='TEXT' ||
                                            element.snowflake_metadata.data_type=='STRING'){
                                            <span
                                                class="data-type data-type-text">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type=='DATE' ||
                                            element.snowflake_metadata.data_type=='DATETIME'
                                            || element.snowflake_metadata.data_type=='TIME' ||
                                            element.snowflake_metadata.data_type=='TIMESTAMP'
                                            || element.snowflake_metadata.data_type=='TIMESTAMP_LTZ' ||
                                            element.snowflake_metadata.data_type=='TIMESTAMP_NTZ'
                                            || element.snowflake_metadata.data_type=='TIMESTAMP_TZ'){
                                            <span
                                                class="data-type data-type-date">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type=='BOOLEAN'){
                                            <span
                                                class="data-type data-type-boolean">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type=='ARRAY' ||
                                            element.snowflake_metadata.data_type=='OBJECT'
                                            || element.snowflake_metadata.data_type=='MAP'){
                                            <span
                                                class="data-type data-type-array">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type=='DOUBLE' ||
                                            element.snowflake_metadata.data_type=='FLOAT'
                                            || element.snowflake_metadata.data_type=='FLOAT4' ||
                                            element.snowflake_metadata.data_type=='FLOAT8'
                                            || element.snowflake_metadata.data_type=='DOUBLE PRECISION' ||
                                            element.snowflake_metadata.data_type=='DECFLOAT'
                                            || element.snowflake_metadata.data_type=='REAL'){
                                            <span
                                                class="data-type data-type-double">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type=='NUMBER' ||
                                            element.snowflake_metadata.data_type=='DECIMAL'
                                            || element.snowflake_metadata.data_type=='NUMERIC' ||
                                            element.snowflake_metadata.data_type=='INTEGER'
                                            || element.snowflake_metadata.data_type=='INT' ||
                                            element.snowflake_metadata.data_type=='BIGINT'
                                            || element.snowflake_metadata.data_type=='TINYINT' ||
                                            element.snowflake_metadata.data_type=='BYTEINT'){
                                            <span
                                                class="data-type data-type-number">{{element.snowflake_metadata.data_type}}</span>
                                            }@else if(element.snowflake_metadata.data_type==''){
                                            }@else{
                                            <span
                                                class="data-type data-type-other">{{element.snowflake_metadata.data_type}}</span>
                                            }
                                        </td>

                                        <td class="data-cell" *ngIf="isAtlanDatabase">
                                            <span class="truncate-multiline"
                                                [matTooltip]="element.atlan_metadata.terms"
                                                matTooltipPosition="below"
                                                matTooltipClass="tooltip-wide">{{element.atlan_metadata.terms}}</span>
                                        </td>

                                        <td class="data-cell" *ngIf="isAtlanDatabase">
                                            <span class="truncate-multiline"
                                                [matTooltip]="element.atlan_metadata.description"
                                                matTooltipPosition="below"
                                                matTooltipClass="tooltip-wide">{{element.atlan_metadata.description}}</span>
                                        </td>

                                        <td class="data-cell" *ngIf="isAtlanDatabase">
                                            @if(element.atlan_metadata.data_type=='TEXT' ||
                                            element.atlan_metadata.data_type=='STRING'){
                                            <span
                                                class="data-type data-type-text">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type=='DATE' ||
                                            element.atlan_metadata.data_type=='DATETIME'
                                            || element.atlan_metadata.data_type=='TIME' ||
                                            element.atlan_metadata.data_type=='TIMESTAMP'
                                            || element.atlan_metadata.data_type=='TIMESTAMP_LTZ' ||
                                            element.atlan_metadata.data_type=='TIMESTAMP_NTZ'
                                            || element.atlan_metadata.data_type=='TIMESTAMP_TZ'){
                                            <span
                                                class="data-type data-type-date">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type=='BOOLEAN'){
                                            <span
                                                class="data-type data-type-boolean">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type=='ARRAY' ||
                                            element.atlan_metadata.data_type=='OBJECT'
                                            || element.atlan_metadata.data_type=='MAP'){
                                            <span
                                                class="data-type data-type-array">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type=='DOUBLE' ||
                                            element.atlan_metadata.data_type=='FLOAT'
                                            || element.atlan_metadata.data_type=='FLOAT4' ||
                                            element.atlan_metadata.data_type=='FLOAT8'
                                            || element.atlan_metadata.data_type=='DOUBLE PRECISION' ||
                                            element.atlan_metadata.data_type=='DECFLOAT'
                                            || element.atlan_metadata.data_type=='REAL'){
                                            <span
                                                class="data-type data-type-double">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type=='NUMBER' ||
                                            element.atlan_metadata.data_type=='DECIMAL'
                                            || element.atlan_metadata.data_type=='NUMERIC' ||
                                            element.atlan_metadata.data_type=='INTEGER'
                                            || element.atlan_metadata.data_type=='INT' ||
                                            element.atlan_metadata.data_type=='BIGINT'
                                            || element.atlan_metadata.data_type=='TINYINT' ||
                                            element.atlan_metadata.data_type=='BYTEINT'){
                                            <span
                                                class="data-type data-type-number">{{element.atlan_metadata.data_type}}</span>
                                            }@else if(element.atlan_metadata.data_type==''){
                                            }@else{
                                            <span
                                                class="data-type data-type-other">{{element.atlan_metadata.data_type}}</span>
                                            }
                                        </td>

                                        <td class="data-cell">
                                            @if (currentActiveRowIndex==i && enableEditing &&
                                            currentActiveMetadataIndex==itemIndex) {
                                            <mat-form-field appearance="outline"
                                                class="inline-field description-field small-height w-100">
                                                <textarea matInput [(ngModel)]="element.column_description_instruction"
                                                    placeholder="Enter Instruction" rows="1" maxlength="200">
                                                    </textarea>
                                                <button mat-icon-button matSuffix
                                                    matTooltip="Expand for detailed editing"
                                                    (click)="openDescriptionDialog('column',item, element)"
                                                    class="expand-btn">
                                                    <mat-icon>open_in_full</mat-icon>
                                                </button>
                                                <mat-hint align="end">{{element.column_description_instruction?.length
                                                    || 0}}/200</mat-hint>
                                            </mat-form-field>
                                            } @else {
                                            <span class="truncate-multiline"
                                                [matTooltip]="element.column_description_instruction"
                                                matTooltipPosition="below"
                                                matTooltipClass="tooltip-wide">{{element.column_description_instruction}}</span>
                                            }
                                        </td>
                                        <td class="action-cell">
                                            @if (currentActiveRowIndex==i && enableEditing &&
                                            currentActiveMetadataIndex==itemIndex) {
                                            <button class="action-btn action-save" (click)="saveItem(i,item)">
                                                <span class="action-icon-wrapper">
                                                    <i class="fas fa-save action-save-icon"></i>
                                                </span>
                                            </button>
                                            } @else {
                                            <button class="action-btn" (click)="enableEdit(i,item, itemIndex)">
                                                <span class="action-icon-wrapper">
                                                    <i class="fas fa-edit"></i>
                                                </span>
                                            </button>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Table Description Dialog -->
<ng-template #descriptionDialog>
    <div class="description-dialog">
        <h2 mat-dialog-title>
            <mat-icon>description</mat-icon>
            Table Description Editor
        </h2>

        <mat-dialog-content class="dialog-content">
            <mat-form-field appearance="outline" class="full-width-field small-height dialog-textarea-container">
                <mat-label>Detailed Table Description</mat-label>
                <textarea matInput [(ngModel)]="tableDescriptionFull"
                    placeholder="Provide a comprehensive description of this table, including its purpose, data sources, update frequency, and any important business context..."
                    rows="8" maxlength="200" class="description-textarea">
                </textarea>
                <mat-hint align="end">{{tableDescriptionFull.length || 0}}/200 characters</mat-hint>
            </mat-form-field>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions">
            <button mat-button (click)="closeDescriptionDialog()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
            <button mat-button (click)="clearDescription()" class="clear-btn">
                <mat-icon>clear_all</mat-icon>
                Clear
            </button>
            <button mat-raised-button color="primary" (click)="saveDescription('table')" class="save-btn">
                <mat-icon>save</mat-icon>
                Save Description
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>

<!-- Column Description Dialog -->
<ng-template #columnDescriptionDialog>
    <div class="description-dialog">
        <h2 mat-dialog-title>
            <mat-icon>description</mat-icon>
            Description Editor
        </h2>

        <mat-dialog-content class="dialog-content">
            <mat-form-field appearance="outline" class="full-width-field small-height dialog-textarea-container">
                <mat-label>Detailed Description</mat-label>
                <textarea matInput [(ngModel)]="columnDescriptionFull"
                    placeholder="Provide a comprehensive description of this column, including its purpose, data sources, update frequency, and any important business context..."
                    rows="8" maxlength="200" class="description-textarea">
                </textarea>
                <mat-hint align="end">{{columnDescriptionFull.length || 0}}/200 characters</mat-hint>
            </mat-form-field>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions">
            <button mat-button (click)="closeDescriptionDialog()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
            <button mat-button (click)="clearDescription()" class="clear-btn">
                <mat-icon>clear_all</mat-icon>
                Clear
            </button>
            <button mat-raised-button color="primary" (click)="saveDescription('column')" class="save-btn">
                <mat-icon>save</mat-icon>
                Save Description
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>

<div *ngIf="isLoading || generateDescriptionLoading" class="main-loading-container">
    <div class="loader-circle-11">
        <div class="arc"></div>
        <div class="arc"></div>
        <div class="arc"></div>
    </div>
    <br />
    <div class="loader-message" *ngIf="databases.length==0 && !generateDescriptionLoading">We are fetching databases
    </div>
    <div class="loader-message" *ngIf="generateDescriptionLoading">We are generating classifications. This may take a
        while.
    </div>
</div>